import script from "./AquariumHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AquariumHeader.vue?vue&type=script&setup=true&lang=js"

import "./AquariumHeader.vue?vue&type=style&index=0&id=50087764&lang=css"

const __exports__ = script;

export default __exports__